import {
	GET_ABANDONED_CART_TEMPLATE_CONNECTIONS,
	UPDATE_TEMPLATE_CONNECTIONS,

	GET_ABANDONED_CART_TEMPLATE_CONNECTION,
	ERROR_GET_ABANDONED_CART_TEMPLATE_CONNECTION,
	UPDATE_TEMPLATE_CONNECTION_BY_ID,
	ERROR_UPDATE_TEMPLATE_CONNECTION_BY_ID,
	UPDATE_SAMPLE_EMAIL_RECIPIENT_EMAIL,
	RENDER_ABANDONED_CART_EMAIL_TEMPLATE,
	// ERROR_RENDER_ABANDONED_CART_EMAIL_TEMPLATE,
	SEND_SAMPLE_EMAIL,
	UPDATE_FORM_FIELD,
	UPDATE_FORM_FIELD_FOR_GENERAL_SETTINGS_PAGE,
	RESET_ALERT_MESSAGE,
	RESET,
	ERROR_GET_IN_PROGRESS_PAYMENTS,
	GET_IN_PROGRESS_PAYMENTS
} from '../../../constants';

const dashboardSettingsState = {
	// General Settings Tab
	meta: null,
	templateConnectionFirstEmail: null,
	templateConnectionSecondEmail: null,
	templateConnectionThirdEmail: null,
	payments: null,

	// customization Tab
	html: '',
	isHtmlUpdated: false,
	templateConnection: null,
	sampleEmailRecipientEmail: ''
};

export default function dashboardEmailsSettingsReducer(state = dashboardSettingsState, action) {
	switch (action.type) {
		case GET_ABANDONED_CART_TEMPLATE_CONNECTIONS:
		case UPDATE_TEMPLATE_CONNECTIONS:
			return Object.assign({}, state, {
				meta: action.meta,
				templateConnectionFirstEmail: action.templateConnectionFirstEmail,
				templateConnectionSecondEmail: action.templateConnectionSecondEmail,
				templateConnectionThirdEmail: action.templateConnectionThirdEmail
			});

		case GET_IN_PROGRESS_PAYMENTS:
			return Object.assign({}, state, {
				payments: action.payments
			});

		case GET_ABANDONED_CART_TEMPLATE_CONNECTION:
		case UPDATE_TEMPLATE_CONNECTION_BY_ID:
			return Object.assign({}, state, {
				meta: action.meta,
				templateConnection: action.templateConnection,
				isHtmlUpdated: false
			});

		case UPDATE_SAMPLE_EMAIL_RECIPIENT_EMAIL:
			return Object.assign({}, state, {
				sampleEmailRecipientEmail: action.sampleEmailRecipientEmail
			});

		case RENDER_ABANDONED_CART_EMAIL_TEMPLATE:
			return Object.assign({}, state, {
				html: action.html,
				isHtmlUpdated: true
			});

		case ERROR_UPDATE_TEMPLATE_CONNECTION_BY_ID:
		case ERROR_GET_ABANDONED_CART_TEMPLATE_CONNECTION:
		case ERROR_GET_IN_PROGRESS_PAYMENTS:
		case SEND_SAMPLE_EMAIL:
			return Object.assign({}, state, {
				meta: action.meta
			});

		case UPDATE_FORM_FIELD_FOR_GENERAL_SETTINGS_PAGE:
			return Object.assign({}, state, {
				templateConnectionFirstEmail: action.templateConnectionFirstEmail,
				templateConnectionSecondEmail: action.templateConnectionSecondEmail,
				templateConnectionThirdEmail: action.templateConnectionThirdEmail
			});

		case UPDATE_FORM_FIELD:
			return Object.assign({}, state, {
				templateConnection: action.templateConnection,
				isHtmlUpdated: false
			});

		case RESET_ALERT_MESSAGE:
			return Object.assign({}, state, {
				meta: null
			});

		case RESET:
			return Object.assign({}, dashboardSettingsState);

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/containers/dashboard-emails-settings-page/reducers/index.js